import axios from 'axios'
import Actualizar from '.././Actualizarregistro'
export default {
  name: 'Biblioteca',
  components: { Actualizar },
  data () {
    return {
      errores: [], nombrecategoria: ''
    }
  },
  created () {
    if (!this.$store.getters.islogin) {
      this.$router.push('/login')
    } else {
      this.consultarpedidosapi()  
    }
  },
  methods: {
    listapedidos (lista) {
      return _.orderBy(lista, ['id'], ['desc'])
    },
    consultarpedidosapi () {
      if (this.$store.getters.islogin === true){
          axios.get(this.$apibase+'gen/biblioteca/', {
            params: {
              'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual
            }
          })
          .then( response => this.procesarbiblioteca(response),  response => this.errorprocesarpedidos(response) )
          .catch( response => this.errorprocesarpedidos(response))
      } else {
        errorprocesarpedidos ('notcred')
      }
    },
    procesarbiblioteca (response) {
      if(response.data.estado === 1){
        this.$store.dispatch('SET_CATEGORIAS', response.data.categorias)
      }
    },
    errorprocesarpedidos (response) {
      console.log(response)
    },
    volveratras () {
      this.$router.push('/listador')
    },
    ircategoria(id) {
      this.$router.push('/categoria/'+id)
    },
    crearcategoria() {
      axios.post(this.$apibase+'gen/nuevacategoria', {
        "categoria": this.nombrecategoria, "cred": this.$store.getters.credactual, '4665': this.$store.getters.idactual
      })
      .then( response => this.pasocrear(response),  response => this.errorcrear(response) )
      .catch( response => this.errorcrear(response))
    },
    pasocrear (response) {
      if (response.data.estado === 1) {
        this.$store.dispatch('SET_CATEGORIAS', response.data.categorias)
        this.nombrecategoria = ''
      }
    },
    errorcrear (response) {

    }
  },
  computed: {
    categorias () {
      return _.orderBy(this.$store.getters.categorias, ['id'], ['desc'])
    }
  },
  watch: {
  }
}


// WEBPACK FOOTER //
// ./src/components/js/biblioteca.js